import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';
import { combineCallDateAndTimes } from './getPortcallDetails';

export async function getPortcallSyncChanges(callId: string | number) {
  const data = await apiGet(`portcall/syncchanges/${callId}`);
  const changes = combineCallDateAndTimes(data.payload);
  usePortcallStore().setCallSyncChanges(changes);
}
